/**
 * ImportButton component for submitting the import form.
 * Shows loading state and disables when conditions aren't met.
 *
 * @param {Object} props - Component props
 * @param {boolean} props.isSubmitting - Whether form is currently submitting
 * @param {boolean} props.isDisabled - Whether button should be disabled
 * @returns {React.ReactElement} Import button
 */
export default function ImportButton({ isSubmitting, isDisabled }) {
  return (
    <button
      type="submit"
      className="import-button"
      disabled={isSubmitting || isDisabled}
      aria-busy={isSubmitting}
    >
      {isSubmitting ? (
        <>
          <span className="import-button__spinner" aria-hidden="true"></span>
          <span>Importowanie...</span>
        </>
      ) : (
        <span>Importuj fiszki</span>
      )}
    </button>
  )
}
